export var AnalysisPlansSortColumn;
(function (AnalysisPlansSortColumn) {
    AnalysisPlansSortColumn["NAME"] = "name";
    AnalysisPlansSortColumn["OWNER_NAME"] = "owner_name";
    AnalysisPlansSortColumn["MODIFY_DATE"] = "user_modify_date";
    AnalysisPlansSortColumn["CREATE_DATE"] = "create_date";
})(AnalysisPlansSortColumn || (AnalysisPlansSortColumn = {}));
export var AnalysisPlansDropdownOption;
(function (AnalysisPlansDropdownOption) {
    AnalysisPlansDropdownOption["SHARE"] = "share";
    AnalysisPlansDropdownOption["RENAME"] = "rename";
    AnalysisPlansDropdownOption["MOVE"] = "move";
    AnalysisPlansDropdownOption["DELETE"] = "delete";
})(AnalysisPlansDropdownOption || (AnalysisPlansDropdownOption = {}));
